import { useCallback } from "react";

import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { useAuth } from "src/lib/auth";
import { isAdminRole } from "src/lib/roles";

export const adminPrivacyModeAtom = atomWithStorage("adminPrivacyMode", false);

export const useAdminPrivacyMode = () => {
  const { currentUser } = useAuth();
  const [privacyMode, setPrivacyMode] = useAtom(adminPrivacyModeAtom);
  const isAdmin = isAdminRole(currentUser?.role);
  const enabled = Boolean(isAdmin && privacyMode);

  const setEnabled = useCallback(
    (next) => {
      if (!isAdmin) return;
      setPrivacyMode(next);
    },
    [isAdmin, setPrivacyMode]
  );

  return { isAdmin, privacyMode: enabled, setPrivacyMode: setEnabled };
};
